import { Box, styled } from "@mui/material";

import { QuickFilterType, TBackground } from "@store/actions/quickFilters";

export const StyledQuickFilter = styled(Box)<{
  tileImageUrl: string;
  type: QuickFilterType;
  bg: TBackground;
  isDesktop: boolean;
}>`
  aspect-ratio: ${({ type }) => (type !== QuickFilterType.BIG ? "2.25 / 1" : "1 / 1")};
  background-image: linear-gradient(0deg, rgba(60, 43, 32, 0.8), rgba(60, 43, 32, 0.8)),
    conic-gradient(from 0deg at 100% 0%, rgba(0, 0, 0, 0) 0deg, #c79c68 183.46deg, rgba(0, 0, 0, 0) 360deg),
    url("${({ tileImageUrl }) => tileImageUrl}");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  font-family: Kaisei Opti;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0%;
  color: #ffdca8;
  cursor: pointer;
  text-align: center;
  font-size: ${({ type, isDesktop }) => (type !== QuickFilterType.BIG || !isDesktop ? "0.875rem" : "1rem")};
  min-height: 56px;

  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ type, isDesktop }) => (type !== QuickFilterType.BIG || !isDesktop ? "8px" : "32px")};

  &:hover {
    background-image: linear-gradient(
      92.95deg,
      #ba905c 0.82%,
      #ffd29b 33.73%,
      #ffe0b1 47.65%,
      #ffd29b 61.53%,
      #ba905c 99.48%
    );
    color: #4b3628;
  }
`;
